const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'tableSimple',
		'table'
	],

	config: {
		isSortable: true,
		lazyloadStepSize: 25,
		preventSortOfField: {
			// tags: true
		},
		buttonContext: 'subscriber',
		renderEmptyBeforReady: false,
		showHead: false,
		showInsertButton: false,
		showColorCodedRows: true,
		showAllBorders: true,
		showDelimiterBorders: true,
		inline: true,
		maxNrOfExportElements: 500000,
		privilegeBase: 'nl_subscribers',
		rowActionsProperties: {
			colWidth: '43px'
		},
		rowActions: {
			delete: true
		},
	},

	model: {
		actionInEffect: '',
		actionModeInEffect: '',
		limitSubscribersToMailingID: false,
		postProcessingOptions: {},
		resourceFilters: {
			order: [{
				fieldCode: 'lastName',
				direction: 'asc'
			},{
				fieldCode: 'subscriberID',
				direction: 'asc'
			}]
		}
	},

	methods: {

		sanitizeResourceFilters: function(storage, resourceFilters, actionKey){
			// split mailingListSegment combined field into mailingListID and segmentID if necessary
			if(((resourceFilters || {}).filters || {}).mailingListSegment){
				var mailingListSegment = String(resourceFilters.filters.mailingListSegment || '').split('|');
				resourceFilters.filters.mailingListID = mailingListSegment[0] || undefined;
				resourceFilters.filters.segmentID = mailingListSegment[1] || undefined;
			}

			// set subscriber limiting mailingID uf necessary
			if(actionKey === 'refreshResources' && this.model.limitSubscribersToMailingID === false){
				var subscriberSpecifics = this.getResourceRegisterContent('subscriberSpecifics') || {};
				this.model.limitSubscribersToMailingID = subscriberSpecifics.mailingID || 0;
				this.model.postProcessingOptions = subscriberSpecifics.postProcessingOptions || {};
				if((this.model.postProcessingOptions || {}).isPostProcessing){
					this.config.rowActions.delete = false;
				}
			}

			if(actionKey !== 'load_mailingListAdditionalFields' && actionKey !== 'delete_mailings_subscriber' && this.model.limitSubscribersToMailingID) {
				if(!resourceFilters.filters) resourceFilters.filters = {}
				resourceFilters.filters.mailingID 				= this.model.limitSubscribersToMailingID;
				resourceFilters.filters.postProcessingOptions 	= this.model.postProcessingOptions;
			}

			return resourceFilters;
		},

		addEntity: function(entity){
			// add entity to dom if possible
			if(this.config.isReady && (this.model.$table || []).length > 0){
				this.model.$table.append(this.include('./row', { config: this.config, resourceData: entity, model: this.model }));
			}
		},

		showInsert: function(rowID, rowData, buttonMode){
			this.model.actionInEffect = 'newSubscriber';
			this.performAndStoreAction(
				'showChooseMailingList_inEffect',
				this.prepareAction('showChooseMailingList'),
				true
			)
		},

		showEdit: function(rowID, rowData, buttonMode){
			var self = this;
			self.model.actionInEffect = 'editSubscriber';

			if (rowID && this.model.controller) {
				var entityAttributes = (rowData || {}).attributes || {};

				var loadAdditionalFieldsPromise = utils.promise.resolve({});
				if(entityAttributes.mailingListAdditionalDataComponentID){
					loadAdditionalFieldsPromise = self.performAction(self.prepareAction('load_mailingListAdditionalFields', entityAttributes.mailingListAdditionalDataComponentID));
				}

				loadAdditionalFieldsPromise
					.then(function(context){
						return self.performAndStoreAction(
							'showEdit_subscriber_inEffect',
							self.prepareAction('showEdit_subscriber', rowID, {
								mailingListData: {
									mailingListID: 				entityAttributes.mailingListID,
									additionalDataComponentID: 	entityAttributes.mailingListAdditionalDataComponentID
								},
								mailingListAdditionalFields: 	(context.action || {}).response || []
							}),
							true
						)
					})
				;
			}
		},

		showImport: function(rowID, rowData, buttonMode){
			var self = this;

			return self.performDecision(
				'chooseImportType',
				{
					component:  self,
					title:      storage.__('newsletter.subscribers.import.chooseType.title'),
					message:    storage.__('newsletter.subscribers.import.chooseType.message'),
					sizeClass:  'small'
				}
			).then(function(context){
				if(
					context.decision.type === 'import'
					&&
					(
						context.decision.mode === 'create' ||
						context.decision.mode === 'removeProperties' ||
						context.decision.mode === 'setProperties'
					)
				){
					self.model.actionInEffect = 'importSubscribers';
					self.model.actionModeInEffect = context.decision.mode;

					return self.performAndStoreAction(
						'showChooseMailingList_inEffect',
						self.prepareAction('showChooseMailingList', undefined, {
							chooseMailingList: {
								preventMailingIDSelection: context.decision.mode !== 'create'
							}
						}),
						true
					);
				}
			});
		},

		export: function(){
			var self = this;

			var nrOfMatchingElements = ((((self.resourceData || {}).nrOfElements || {}).data || {}).attributes || {}).nrOfMatchingElements || 0;
			if(nrOfMatchingElements > self.config.maxNrOfExportElements){
				return self.performDecision(
					'confirm',
					{
						component:  self,
						title:      storage.__('hint.newsletter.subscriber.export.limit.title'),
						message:    storage.__('hint.newsletter.subscriber.export.limit.message', { max: self.config.maxNrOfExportElements, nrOfMatchingElements: nrOfMatchingElements })
					}
				).then(function(confirmationContext){
					if(confirmationContext.decision.type === 'yes'){
						self.startExport();
					}
				});
			}

			self.startExport();
		},

		startExport: function(mode, forceExtension){
			var resourceFilters 	= utils.copy(this.getResourceFilters(storage, undefined, 'refreshResources')) || {};
			resourceFilters.offset 	= 0;
			resourceFilters.limit 	= this.config.maxNrOfExportElements;
			var filename = 'newsletter_subscribers_' + utils.moment().format('YYYY-MM-DD_hh-mm-ss') + '.xlsx';

			if (
				((resourceFilters.filters || {}).segmentID && (resourceFilters.filters.segmentID * 1))
				||
				this.hasRoleOption('fullSubscriberExportGranted')
			){
				window.open('/LTR/~/exports/newsletter/subscribers/' + (mode || 'newsletterSubscribers') + '/' + filename + '?body=' + Buffer.from(JSON.stringify({
					resourceFilters: resourceFilters
				})).toString('base64'), '_blank');
			} else {
				this.performAction(this.prepareAction('message', undefined, {
					messageDisplay: {
						message: 'error:export.newsletter.subscribers.noExportWithoutSegmentID'
					}
				}));
			}
		},

		delete: function(rowID, rowData, buttonMode){
			var self = this;
			var entityAttributes = (rowData || {}).attributes || {};

			if(entityAttributes.subscriberID){
				if(self.model.limitSubscribersToMailingID){
					if((self.model.postProcessingOptions || {}).isPostProcessing){
						return utils.promise.reject(new Error('DELETE SUBSCRIBER WITHIN POST_PROCESSING IS NOT GRANTED'));
					}

					return self.performDecision(
						'confirm',
						{
							component:  self,
							title:      storage.__('hint.delete.really.mailing.subscriber.title'),
							message:    storage.__('hint.delete.really.mailing.subscriber.message')
						}
					).then(function(context) {
						if (context.decision.type === 'yes') {

							return self.performAction(
								self.prepareAction('delete_mailings_subscriber', undefined, undefined, {
									source: {
										submit: {
											data: {
												resourceFilters: {
													subscriberID:	entityAttributes.subscriberID,
													mailingID:		self.model.limitSubscribersToMailingID,
												}
											}
										}
									}
								})
							).then(function(context){
								// refresh list of mailings
								self.refresh();
								return context;
							});
						}

						return utils.promise.reject();
					});
				}

				return self.performDecision(
					'confirm',
					{
						component:  self,
						title:      storage.__('hint.delete.really.subscriber.title'),
						message:    storage.__('hint.delete.really.subscriber.message')
					}
				).then(function(context) {
					if (context.decision.type === 'yes') {

						return self.performAction(
							self.prepareAction('delete_subscriber', undefined, undefined, {
								source: {
									submit: {
										data: {
											data: {
												attributes: {
													subscriberID:	entityAttributes.subscriberID,
													mailingListID:	entityAttributes.mailingListID,
													email:			entityAttributes.email
												}
											}
										}
									}
								}
							})
						).then(function(context){
							// refresh list of mailings
							self.refresh();
							return context;
						});
					}

					return utils.promise.reject();
				});
			}

			return utils.promise.reject(new Error('DELETE SUBSCRIBER MISSING SUBSCRIBER_ID'));
		},
	},

	hooks: {
		_attach: function($element, options){
			var self = this;
			if(!self.model.controller){
				self.closest('templates_newsletter_subscribers_controller', function(controller){
					self.model.controller = controller
				});
			}
		},

		async onDecision($element, options){
			const modal = options.decisionComponent
			if(!modal || !modal.hasClass('base_modal_modal')){
				return
			}

			if(options.decisionType === 'cancel'){
				return modal.hide()
			}

			if(options.decisionComponent.hasClass('container_templates_propertiesForms_subscriberPropertiesForm')){
				let subscriberPropertiesForm
				options.decisionComponent.find('templates_propertiesForms_subscriberPropertiesForm', c => subscriberPropertiesForm = c)
				if(subscriberPropertiesForm){
					if(
						subscriberPropertiesForm.config.codeName === 'setMassSubscriberProperties'
						||
						subscriberPropertiesForm.config.codeName === 'removeMassSubscriberProperties'
					){
						var subscriberImporterUploaderProperties = subscriberPropertiesForm.getResourceRegisterContent('subscriberImporterUploader') || {};
						subscriberImporterUploaderProperties.propertyChanges = (subscriberPropertiesForm.model || {}).dirtyFields || {};

						// cleanup zeros if necessary
						if(subscriberPropertiesForm.config.codeName === 'removeMassSubscriberProperties'){
							var key;
							for(key in (subscriberImporterUploaderProperties.propertyChanges.data || {}).attributes || {}){
								if(
									!subscriberImporterUploaderProperties.propertyChanges.data.attributes[key]
									||
									(
										Array.isArray(subscriberImporterUploaderProperties.propertyChanges.data.attributes[key])
										&&
										subscriberImporterUploaderProperties.propertyChanges.data.attributes[key].length <= 0
									)
								){
									delete subscriberImporterUploaderProperties.propertyChanges.data.attributes[key];
								}
							}
							for(key in ((((subscriberImporterUploaderProperties.propertyChanges.data || {}).children || {}).additionalData || {}).data || {}).attributes || {}){
								if(
									!subscriberImporterUploaderProperties.propertyChanges.data.children.additionalData.data.attributes[key]
									||
									(
										Array.isArray(subscriberImporterUploaderProperties.propertyChanges.data.children.additionalData.data.attributes[key])
										&&
										subscriberImporterUploaderProperties.propertyChanges.data.children.additionalData.data.attributes[key].length <= 0
									)
								){
									delete subscriberImporterUploaderProperties.propertyChanges.data.children.additionalData.data.attributes[key];
								}
							}
						}

						if(
							utils.collectionSize((subscriberImporterUploaderProperties.propertyChanges.data || {}).attributes) <= 0
							&&
							utils.collectionSize(((((subscriberImporterUploaderProperties.propertyChanges.data || {}).children || {}).additionalData || {}).data || {}).attributes) <= 0
						){
							return this.performAction(this.prepareAction('message', undefined, {
								messageDisplay: {
									message: 'error:newsletter.subscriber.import.missingPropertyChanges.' + (subscriberImporterUploaderProperties.setPropertiesType || 'setProperties')
								}
							}));
						}

						await options.decisionComponent.hide()

						return this.performAction(
							this.prepareAction('show_subscriberImporter', undefined, {
								subscriberImporterUploader: subscriberImporterUploaderProperties
							})
						);
					} else {
						await subscriberPropertiesForm.submit()
						await options.decisionComponent.hide()
						this.refreshData(true)
					}
				}
			} else if (options.decisionComponent.hasClass('container_templates_newsletter_subscribers_chooseMailingListForm')){
				let chooseMailingListForm
				options.decisionComponent.find('templates_newsletter_subscribers_chooseMailingListForm', c => chooseMailingListForm = c)
				if(chooseMailingListForm){
					var mailingListData = String((((chooseMailingListForm.model.dirtyFields || {}).data || {}).attributes || {}).mailingListAndComponentID || '').split('_');
					if(mailingListData.length > 1){

						var mailingID = ((((chooseMailingListForm.model.dirtyFields || {}).data || {}).attributes || {}).mailingID || 0);

						mailingListData = {
							mailingListID: 				mailingListData[0],
							additionalDataComponentID: 	mailingListData[1],
							mailingID:					mailingID
						};

						await options.decisionComponent.hide()

						if(this.model.actionInEffect === 'importSubscribers' && this.model.actionModeInEffect === 'create') {
							return this.performAction(
								this.prepareAction('show_subscriberImporter', undefined, {
									subscriberImporterUploader: {
										mailingListID: (mailingListData || {}).mailingListID,
										mailingID: mailingID
									}
								})
							)
						}

						let loadAdditionalFieldsContext = {}
						if(mailingListData.additionalDataComponentID){
							loadAdditionalFieldsContext = await this.performAction(this.prepareAction('load_mailingListAdditionalFields', mailingListData.additionalDataComponentID))
						}

						if(this.model.actionInEffect === 'importSubscribers'){
							if(this.model.actionModeInEffect === 'setProperties'){
								return this.performAction(
									this.prepareAction('showSelect_setMassSubscriberProperties', undefined, {
										mailingListData: 				mailingListData,
										mailingListAdditionalFields: 	(loadAdditionalFieldsContext.action || {}).response || {},
										subscriberImporterUploader: {
											mailingListID:		(mailingListData || {}).mailingListID,
											mailingID:			mailingID,
											setPropertiesType: 	this.model.actionModeInEffect
										}
									})
								)
							}

							if(this.model.actionModeInEffect === 'removeProperties'){
								return this.performAction(
									this.prepareAction('showSelect_removeMassSubscriberProperties', undefined, {
										mailingListData: 				mailingListData,
										mailingListAdditionalFields: 	(loadAdditionalFieldsContext.action || {}).response || {},
										subscriberImporterUploader: {
											mailingListID:		(mailingListData || {}).mailingListID,
											mailingID:			mailingID,
											setPropertiesType: 	this.model.actionModeInEffect
										}
									})
								)
							}
						}

						return this.performAction(
							this.prepareAction('showInsert_subscriber', undefined, {
								mailingListData: 				mailingListData,
								mailingListAdditionalFields: 	(loadAdditionalFieldsContext.action || {}).response || {}
							})
						)
					}

					return this.performAction(
						this.prepareAction('message', undefined, {
							messageDisplay: {
								message: 'error:newsletter.subscriber.insert.missingMailingList'
							}
						})
					)
				}

				if (options.decisionComponent.hasClass('container_templates_newsletter_subscribers_importer')) {
					this.refreshData(true)
					options.decisionComponent.hide()
				}
			}
		}
	},

	handlers: [
		{
			name: 'refreshAfterMailingSegmentsChange',
			handle: function(callerComponent, nodeData, insertPerformed){
				this.refreshData(true);
			}
		}
	]
}